/**
 *  update by tannc 2018年12月24日20:33:50
 */

import { STAGE_SAVE_API,STAGE_ENABLE_API,STAGES_API } from '../resource/index';
import axios from '../config/axios.config';
export default {

   async save(params) {
      return await axios.save(STAGE_SAVE_API,{},params);
   },
  async enableOrDisable(params) {
    return await axios.update(STAGE_ENABLE_API,params,{});
  },
  async fetchData() {
    return await axios.get(STAGES_API,{},{});
  }


}



// WEBPACK FOOTER //
// ./src/service/learnService.js